import { useState, useEffect, useRef } from "react";
import useSwipeBack from "./useSwipeBack";
import { AudioAltar } from "./AudioAltar";

// Full Quran recitation by Sheikh Yasser Al Dossari
// 114 surahs streamed via backend proxy from qurancentral.com

const BACKEND = "https://azaan-backend.onrender.com";
const audioUrl = (num) => `${BACKEND}/api/audio/qc/yasser-al-dossari/yasser-al-dossari-${String(num).padStart(3, "0")}`;

const SURAHS = [
  { num:1,   name:"Al-Fatiha",      arabic:"الفاتحة" },
  { num:2,   name:"Al-Baqarah",     arabic:"البقرة" },
  { num:3,   name:"Aal-Imran",      arabic:"آل عمران" },
  { num:4,   name:"An-Nisa",        arabic:"النساء" },
  { num:5,   name:"Al-Ma'idah",     arabic:"المائدة" },
  { num:6,   name:"Al-An'am",       arabic:"الأنعام" },
  { num:7,   name:"Al-A'raf",       arabic:"الأعراف" },
  { num:8,   name:"Al-Anfal",       arabic:"الأنفال" },
  { num:9,   name:"At-Tawbah",      arabic:"التوبة" },
  { num:10,  name:"Yunus",          arabic:"يونس" },
  { num:11,  name:"Hud",            arabic:"هود" },
  { num:12,  name:"Yusuf",          arabic:"يوسف" },
  { num:13,  name:"Ar-Ra'd",        arabic:"الرعد" },
  { num:14,  name:"Ibrahim",        arabic:"إبراهيم" },
  { num:15,  name:"Al-Hijr",        arabic:"الحجر" },
  { num:16,  name:"An-Nahl",        arabic:"النحل" },
  { num:17,  name:"Al-Isra",        arabic:"الإسراء" },
  { num:18,  name:"Al-Kahf",        arabic:"الكهف" },
  { num:19,  name:"Maryam",         arabic:"مريم" },
  { num:20,  name:"Ta-Ha",          arabic:"طه" },
  { num:21,  name:"Al-Anbiya",      arabic:"الأنبياء" },
  { num:22,  name:"Al-Hajj",        arabic:"الحج" },
  { num:23,  name:"Al-Mu'minun",    arabic:"المؤمنون" },
  { num:24,  name:"An-Nur",         arabic:"النور" },
  { num:25,  name:"Al-Furqan",      arabic:"الفرقان" },
  { num:26,  name:"Ash-Shu'ara",    arabic:"الشعراء" },
  { num:27,  name:"An-Naml",        arabic:"النمل" },
  { num:28,  name:"Al-Qasas",       arabic:"القصص" },
  { num:29,  name:"Al-Ankabut",     arabic:"العنكبوت" },
  { num:30,  name:"Ar-Rum",         arabic:"الروم" },
  { num:31,  name:"Luqman",         arabic:"لقمان" },
  { num:32,  name:"As-Sajdah",      arabic:"السجدة" },
  { num:33,  name:"Al-Ahzab",       arabic:"الأحزاب" },
  { num:34,  name:"Saba",           arabic:"سبأ" },
  { num:35,  name:"Fatir",          arabic:"فاطر" },
  { num:36,  name:"Ya-Sin",         arabic:"يس" },
  { num:37,  name:"As-Saffat",      arabic:"الصافات" },
  { num:38,  name:"Sad",            arabic:"ص" },
  { num:39,  name:"Az-Zumar",       arabic:"الزمر" },
  { num:40,  name:"Ghafir",         arabic:"غافر" },
  { num:41,  name:"Fussilat",       arabic:"فصلت" },
  { num:42,  name:"Ash-Shura",      arabic:"الشورى" },
  { num:43,  name:"Az-Zukhruf",     arabic:"الزخرف" },
  { num:44,  name:"Ad-Dukhan",      arabic:"الدخان" },
  { num:45,  name:"Al-Jathiyah",    arabic:"الجاثية" },
  { num:46,  name:"Al-Ahqaf",       arabic:"الأحقاف" },
  { num:47,  name:"Muhammad",       arabic:"محمد" },
  { num:48,  name:"Al-Fath",        arabic:"الفتح" },
  { num:49,  name:"Al-Hujurat",     arabic:"الحجرات" },
  { num:50,  name:"Qaf",            arabic:"ق" },
  { num:51,  name:"Adh-Dhariyat",   arabic:"الذاريات" },
  { num:52,  name:"At-Tur",         arabic:"الطور" },
  { num:53,  name:"An-Najm",        arabic:"النجم" },
  { num:54,  name:"Al-Qamar",       arabic:"القمر" },
  { num:55,  name:"Ar-Rahman",      arabic:"الرحمن" },
  { num:56,  name:"Al-Waqi'ah",     arabic:"الواقعة" },
  { num:57,  name:"Al-Hadid",       arabic:"الحديد" },
  { num:58,  name:"Al-Mujadila",    arabic:"المجادلة" },
  { num:59,  name:"Al-Hashr",       arabic:"الحشر" },
  { num:60,  name:"Al-Mumtahina",   arabic:"الممتحنة" },
  { num:61,  name:"As-Saff",        arabic:"الصف" },
  { num:62,  name:"Al-Jumu'ah",     arabic:"الجمعة" },
  { num:63,  name:"Al-Munafiqun",   arabic:"المنافقون" },
  { num:64,  name:"At-Taghabun",    arabic:"التغابن" },
  { num:65,  name:"At-Talaq",       arabic:"الطلاق" },
  { num:66,  name:"At-Tahrim",      arabic:"التحريم" },
  { num:67,  name:"Al-Mulk",        arabic:"الملك" },
  { num:68,  name:"Al-Qalam",       arabic:"القلم" },
  { num:69,  name:"Al-Haqqah",      arabic:"الحاقة" },
  { num:70,  name:"Al-Ma'arij",     arabic:"المعارج" },
  { num:71,  name:"Nuh",            arabic:"نوح" },
  { num:72,  name:"Al-Jinn",        arabic:"الجن" },
  { num:73,  name:"Al-Muzzammil",   arabic:"المزمل" },
  { num:74,  name:"Al-Muddaththir", arabic:"المدثر" },
  { num:75,  name:"Al-Qiyamah",     arabic:"القيامة" },
  { num:76,  name:"Al-Insan",       arabic:"الإنسان" },
  { num:77,  name:"Al-Mursalat",    arabic:"المرسلات" },
  { num:78,  name:"An-Naba",        arabic:"النبأ" },
  { num:79,  name:"An-Nazi'at",     arabic:"النازعات" },
  { num:80,  name:"Abasa",          arabic:"عبس" },
  { num:81,  name:"At-Takwir",      arabic:"التكوير" },
  { num:82,  name:"Al-Infitar",     arabic:"الانفطار" },
  { num:83,  name:"Al-Mutaffifin",  arabic:"المطففين" },
  { num:84,  name:"Al-Inshiqaq",    arabic:"الانشقاق" },
  { num:85,  name:"Al-Buruj",       arabic:"البروج" },
  { num:86,  name:"At-Tariq",       arabic:"الطارق" },
  { num:87,  name:"Al-A'la",        arabic:"الأعلى" },
  { num:88,  name:"Al-Ghashiyah",   arabic:"الغاشية" },
  { num:89,  name:"Al-Fajr",        arabic:"الفجر" },
  { num:90,  name:"Al-Balad",       arabic:"البلد" },
  { num:91,  name:"Ash-Shams",      arabic:"الشمس" },
  { num:92,  name:"Al-Layl",        arabic:"الليل" },
  { num:93,  name:"Ad-Duha",        arabic:"الضحى" },
  { num:94,  name:"Ash-Sharh",      arabic:"الشرح" },
  { num:95,  name:"At-Tin",         arabic:"التين" },
  { num:96,  name:"Al-Alaq",        arabic:"العلق" },
  { num:97,  name:"Al-Qadr",        arabic:"القدر" },
  { num:98,  name:"Al-Bayyinah",    arabic:"البينة" },
  { num:99,  name:"Az-Zalzalah",    arabic:"الزلزلة" },
  { num:100, name:"Al-Adiyat",      arabic:"العاديات" },
  { num:101, name:"Al-Qari'ah",     arabic:"القارعة" },
  { num:102, name:"At-Takathur",    arabic:"التكاثر" },
  { num:103, name:"Al-Asr",         arabic:"العصر" },
  { num:104, name:"Al-Humazah",     arabic:"الهمزة" },
  { num:105, name:"Al-Fil",         arabic:"الفيل" },
  { num:106, name:"Quraysh",        arabic:"قريش" },
  { num:107, name:"Al-Ma'un",       arabic:"الماعون" },
  { num:108, name:"Al-Kawthar",     arabic:"الكوثر" },
  { num:109, name:"Al-Kafirun",     arabic:"الكافرون" },
  { num:110, name:"An-Nasr",        arabic:"النصر" },
  { num:111, name:"Al-Masad",       arabic:"المسد" },
  { num:112, name:"Al-Ikhlas",      arabic:"الإخلاص" },
  { num:113, name:"Al-Falaq",       arabic:"الفلق" },
  { num:114, name:"An-Nas",         arabic:"الناس" },
];

const fmtTime = (sec) => {
  if (!isFinite(sec) || sec < 0) return "0:00";
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  if (m >= 60) {
    const h = Math.floor(m / 60);
    const mm = m % 60;
    return `${h}:${String(mm).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }
  return `${m}:${String(s).padStart(2, "0")}`;
};

// Module-level singleton — survives component unmount so audio keeps playing
// when the user switches tabs. Never reassigned once created.
let _audio = null;
let _playingNum = null;
const _listeners = new Set();
const _notify = () => _listeners.forEach(cb => { try { cb(); } catch {} });

// Module-level playSurah so the auto-advance handler (which fires from the
// audio element regardless of whether DossariRecitations is mounted) can
// queue the next surah. Component's playSurah delegates here.
//
// IMPORTANT — `isAutoAdvance` skips the explicit `audio.load()` call when
// queueing the next surah after `ended`. iOS WKWebView treats `load()` as
// the start of a NEW playback session that requires a fresh user gesture;
// without a recent tap, the follow-up `play()` rejects with NotAllowedError
// and the spinner buffers forever. Mutating `src` without `load()` is
// recognised as a continuation of the existing media-engagement session,
// so `play()` succeeds and the next surah streams immediately. The error
// is also surfaced now (not swallowed) so future regressions are visible
// in the player UI.
function _playSurahInternal(surah, { isAutoAdvance = false } = {}) {
  const a = getAudio();
  _playingNum = surah.num;
  if ("mediaSession" in navigator) {
    try {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: `${surah.name} (${surah.arabic})`,
        artist: "Yasser Al Dossari",
        album: "Sirat · Full Quran",
        artwork: [{ src: "/logo192.png", sizes: "192x192", type: "image/png" }, { src: "/logo512.png", sizes: "512x512", type: "image/png" }],
      });
      navigator.mediaSession.playbackState = "playing";
    } catch {}
  }
  a.src = audioUrl(surah.num);
  // Skip `load()` on auto-advance — preserves the iOS media session and
  // avoids the autoplay-after-gesture-timeout block. For user-initiated
  // plays we still call load() so a fresh tap always works cleanly.
  if (!isAutoAdvance) a.load();
  const p = a.play();
  if (p && typeof p.catch === "function") {
    p.catch(err => {
      // Persist the failure reason so the player UI / debug overlay can
      // show it instead of buffering silently forever.
      _lastPlayError = err && err.message ? err.message : String(err || "play rejected");
      // Synthesize an "error" event on the audio element so the mounted
      // component's existing onError listener flips loading off and
      // surfaces an actionable message. Without this, play() rejection
      // (iOS autoplay block) shows as an infinite spinner.
      try { a.dispatchEvent(new Event("error")); } catch {}
      _notify();
    });
  }
  _notify();
}

// Exposed so the mounted component can surface auto-advance failures
// (iOS autoplay rejections) instead of spinning the loading indicator
// indefinitely.
let _lastPlayError = null;

const getAudio = () => {
  if (!_audio) {
    _audio = new Audio();
    _audio.preload = "auto";
    _audio.addEventListener("play", _notify);
    _audio.addEventListener("pause", _notify);
    // Auto-advance to the next surah when the current one ends. Works whether
    // the user is on the Dossari screen or anywhere else in the app — the
    // handler lives on the module-level audio element, not on the component.
    // After surah 114 (An-Nas) we stop cleanly.
    _audio.addEventListener("ended", () => {
      const current = _playingNum;
      const idx = SURAHS.findIndex(s => s.num === current);
      if (idx >= 0 && idx < SURAHS.length - 1) {
        // Auto-advance — pass the flag so _playSurahInternal skips
        // `load()` and the iOS media session continues without
        // requiring a fresh user gesture.
        _playSurahInternal(SURAHS[idx + 1], { isAutoAdvance: true });
      } else {
        _playingNum = null;
        if ("mediaSession" in navigator) {
          try { navigator.mediaSession.playbackState = "none"; } catch {}
        }
        _notify();
      }
    });
  }
  return _audio;
};

// Public API used by the global mini player in App.js.
export const dossariPlayer = {
  SURAHS,
  get playingNum() { return _playingNum; },
  get isPlaying() { return !!_audio && !_audio.paused && _playingNum != null; },
  subscribe(cb) { _listeners.add(cb); return () => _listeners.delete(cb); },
  pause() { if (_audio) _audio.pause(); },
  resume() { if (_audio) _audio.play().catch(() => {}); },
  stop() {
    if (_audio) { _audio.pause(); try { _audio.currentTime = 0; } catch {} }
    _playingNum = null;
    if ("mediaSession" in navigator) { try { navigator.mediaSession.playbackState = "none"; } catch {} }
    _notify();
  },
};

export default function DossariRecitations({ darkMode, onBack }) {
  const swipe = useSwipeBack(onBack);
  const audioRef = useRef(null);
  const handlersRef = useRef({});
  const [playingNum, setPlayingNum] = useState(() => _playingNum);
  const [isPlaying, setIsPlaying] = useState(() => _audio ? !_audio.paused : false);
  const [loading, setLoading] = useState(false);
  const [currentTime, setCurrentTime] = useState(() => _audio ? _audio.currentTime : 0);
  const [duration, setDuration] = useState(() => (_audio && isFinite(_audio.duration)) ? _audio.duration : 0);
  const [errorMsg, setErrorMsg] = useState(null);
  const [search, setSearch] = useState("");

  // Attach/detach event listeners on mount/unmount — never pause the audio
  useEffect(() => {
    const a = getAudio();
    audioRef.current = a;

    const onMeta  = () => handlersRef.current.onMeta();
    const onTime  = () => handlersRef.current.onTime();
    const onPlay  = () => handlersRef.current.onPlay();
    const onPause = () => handlersRef.current.onPause();
    const onEnded = () => handlersRef.current.onEnded();
    const onError = () => handlersRef.current.onError();

    a.addEventListener("loadedmetadata", onMeta);
    a.addEventListener("timeupdate",     onTime);
    a.addEventListener("play",           onPlay);
    a.addEventListener("pause",          onPause);
    a.addEventListener("ended",          onEnded);
    a.addEventListener("error",          onError);

    if ("mediaSession" in navigator) {
      try {
        navigator.mediaSession.setActionHandler("play",         () => a.play().catch(() => {}));
        navigator.mediaSession.setActionHandler("pause",        () => a.pause());
        navigator.mediaSession.setActionHandler("seekbackward", (d) => { a.currentTime = Math.max(0, a.currentTime - (d.seekOffset || 10)); });
        navigator.mediaSession.setActionHandler("seekforward",  (d) => { a.currentTime = Math.min(a.duration || 0, a.currentTime + (d.seekOffset || 10)); });
        // Lock-screen / Bluetooth-headphone next/prev track. These count
        // as user gestures, so they always succeed even when the
        // auto-advance "ended" listener is blocked by autoplay policy.
        navigator.mediaSession.setActionHandler("nexttrack", () => {
          const idx = SURAHS.findIndex(s => s.num === _playingNum);
          if (idx >= 0 && idx < SURAHS.length - 1) _playSurahInternal(SURAHS[idx + 1]);
        });
        navigator.mediaSession.setActionHandler("previoustrack", () => {
          const idx = SURAHS.findIndex(s => s.num === _playingNum);
          if (idx > 0) _playSurahInternal(SURAHS[idx - 1]);
        });
      } catch {}
    }

    return () => {
      a.removeEventListener("loadedmetadata", onMeta);
      a.removeEventListener("timeupdate",     onTime);
      a.removeEventListener("play",           onPlay);
      a.removeEventListener("pause",          onPause);
      a.removeEventListener("ended",          onEnded);
      a.removeEventListener("error",          onError);
      // Do NOT pause — audio keeps playing when user switches tabs
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  handlersRef.current = {
    onMeta: () => {
      const a = audioRef.current;
      if (!a) return;
      setDuration(a.duration);
      setLoading(false);
    },
    onTime: () => {
      const a = audioRef.current;
      if (!a) return;
      setCurrentTime(a.currentTime);
      if ("mediaSession" in navigator && a.duration && isFinite(a.duration)) {
        try {
          navigator.mediaSession.setPositionState({
            duration: a.duration,
            playbackRate: a.playbackRate,
            position: a.currentTime,
          });
        } catch {}
      }
    },
    onPlay:  () => setIsPlaying(true),
    onPause: () => setIsPlaying(false),
    onEnded: () => {
      // Auto-advance happens at the module level (see getAudio above).
      // Sync local state from the module so the row UI tracks the new
      // surah, and prime the loading spinner while the next surah buffers.
      setIsPlaying(_audio ? !_audio.paused : false);
      setPlayingNum(_playingNum);
      if (_playingNum != null) {
        setLoading(true);
        setCurrentTime(0);
        setDuration(0);
      }
    },
    onError: () => {
      const a = audioRef.current;
      // If the most recent failure was a play() rejection (iOS autoplay
      // block on auto-advance), prefer that human-readable message. The
      // native MediaError code is "?" because play() never started a load.
      if (_lastPlayError) {
        setErrorMsg(`Auto-advance blocked: ${_lastPlayError}. Tap Play to continue.`);
        _lastPlayError = null;
      } else {
        const code = a && a.error ? a.error.code : "?";
        const codeMap = { 1: "ABORTED", 2: "NETWORK", 3: "DECODE", 4: "SRC_NOT_SUPPORTED" };
        setErrorMsg(`Audio error: ${codeMap[code] || "code " + code}`);
      }
      setLoading(false);
      setIsPlaying(false);
    },
  };

  const playSurah = (surah) => {
    const a = audioRef.current;
    if (!a) { setErrorMsg("Audio not ready — please retry"); return; }
    setErrorMsg(null);
    _playingNum = surah.num;
    _notify();
    setPlayingNum(surah.num);
    setLoading(true);
    setCurrentTime(0);
    setDuration(0);
    if ("mediaSession" in navigator) {
      try {
        navigator.mediaSession.metadata = new window.MediaMetadata({
          title: `${surah.name} (${surah.arabic})`,
          artist: "Yasser Al Dossari",
          album: "Sirat · Full Quran",
          artwork: [{ src: "/logo192.png", sizes: "192x192", type: "image/png" }, { src: "/logo512.png", sizes: "512x512", type: "image/png" }],
        });
        navigator.mediaSession.playbackState = "playing";
      } catch {}
    }
    a.src = audioUrl(surah.num);
    a.load();
    const p = a.play();
    if (p && typeof p.catch === "function") {
      p.catch(err => {
        setErrorMsg(`Play failed: ${err && err.message ? err.message : "unknown"}`);
        setLoading(false);
        setIsPlaying(false);
      });
    }
  };

  const togglePlay = (surah) => {
    const a = audioRef.current;
    if (!a) return;
    if (playingNum === surah.num) {
      if (isPlaying) a.pause();
      else a.play().catch(() => {});
    } else {
      playSurah(surah);
    }
  };

  const seek = (t) => { const a = audioRef.current; if (a && isFinite(t)) { a.currentTime = t; setCurrentTime(t); } };

  const filtered = search.trim()
    ? SURAHS.filter(s => s.name.toLowerCase().includes(search.toLowerCase()) || s.arabic.includes(search) || String(s.num) === search.trim())
    : SURAHS;

  const accent = darkMode ? "#4fc3f7" : "#0277bd";
  const accentFaint = darkMode ? "rgba(79,195,247,0.08)" : "rgba(2,119,189,0.06)";
  const accentBorder = darkMode ? "rgba(79,195,247,0.25)" : "rgba(2,119,189,0.25)";

  return (
    <div
      onTouchStart={swipe.onTouchStart}
      onTouchMove={swipe.onTouchMove}
      onTouchEnd={swipe.onTouchEnd}
      style={{ display: "flex", flexDirection: "column", height: "100%", background: "var(--bg)", overflowY: "auto", paddingBottom: playingNum !== null ? "calc(160px + env(safe-area-inset-bottom))" : "calc(80px + env(safe-area-inset-bottom))" }}
    >
      {/* Header */}
      <div style={{ padding: "16px 16px 14px", display: "flex", alignItems: "center", gap: "12px", borderBottom: "1px solid var(--border)" }}>
        <button onClick={onBack} style={{ background: "none", border: "none", color: "var(--text)", fontSize: "24px", cursor: "pointer", padding: "4px", lineHeight: 1 }}>‹</button>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: "17px", fontWeight: "800", color: "var(--text)" }}>Sheikh Yasser Al Dossari</div>
          <div style={{ fontSize: "11px", color: accent, fontWeight: "600", marginTop: "2px", fontStyle: "italic" }}>For Hasnain Khan — future Hafiz, In Shaa Allah</div>
        </div>
      </div>

      {errorMsg && (
        <div style={{ margin: "12px 16px 0", padding: "10px 14px", background: "rgba(200,60,60,0.08)", border: "1px solid rgba(200,60,60,0.35)", borderRadius: "12px", fontSize: "11px", color: "#e87878", lineHeight: 1.5, wordBreak: "break-all" }}>
          {errorMsg}
        </div>
      )}

      {/* Hero — AudioAltar */}
      <AudioAltar
        eyebrow="RECITATIONS FROM · QARI #01"
        title="Sheikh Yasser Al Dossari"
        arabicName="ياسر الدوسري"
        portraitInitial="ي"
        tone="gold"
        facts={[
          { label: "ORIGIN",   value: "Saudi Arabia" },
          { label: "SINCE",    value: "2004" },
          { label: "STYLE",    value: "Mujawwad" },
          { label: "SURAHS",   value: "114" },
        ]}
        bio="Imam of Masjid Al-Haram, Makkah. Renowned worldwide for his deeply moving and melodious recitation spanning the complete Mushaf."
        quote={{ text: "Whoever recites the Quran beautifully, God will honour him on the Day of Resurrection.", attribution: "Prophet Muhammad ﷺ" }}
        primaryCta={{ label: "▶ Play Al-Fatiha", onPlay: () => playSurah(SURAHS[0]) }}
      />

      {/* Search */}
      <div style={{ padding: "12px 16px 0" }}>
        <input
          type="text"
          placeholder="Search surahs..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: "100%", padding: "10px 14px", background: "var(--s1)", border: "1px solid var(--border)", borderRadius: "12px", color: "var(--text)", fontSize: "13px", fontFamily: "inherit", outline: "none", boxSizing: "border-box" }}
        />
      </div>

      {/* Surah list */}
      <div style={{ padding: "10px 16px 0" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {filtered.map(s => {
            const active = playingNum === s.num;
            return (
              <div
                key={s.num}
                onClick={() => togglePlay(s)}
                style={{
                  display: "flex", alignItems: "center", gap: "12px", padding: "10px 12px",
                  borderRadius: "12px", background: active ? accentFaint : "var(--s1)",
                  border: `1px solid ${active ? accentBorder : "var(--border)"}`,
                  cursor: "pointer", transition: "all 0.2s ease",
                }}
              >
                <div style={{
                  width: "36px", height: "36px", borderRadius: "10px",
                  background: active ? accent : "var(--s2)",
                  border: `1px solid ${active ? accent : "var(--border)"}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: active ? "#000" : "var(--muted)",
                  fontSize: active && loading ? "11px" : "12px",
                  fontWeight: "800", flexShrink: 0,
                }}>
                  {active && loading ? <span style={{display:"inline-block",width:"14px",height:"14px",border:"2px solid rgba(0,0,0,0.2)",borderTopColor:"#000",borderRadius:"50%",animation:"spin 0.7s linear infinite"}}/> : active && isPlaying ? "⏸" : String(s.num)}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <div style={{ fontSize: "13px", fontWeight: "700", color: "var(--text)" }}>{s.name}</div>
                    <div style={{ fontSize: "13px", color: accent, fontFamily: "'Scheherazade New', serif" }}>{s.arabic}</div>
                  </div>
                  {active && loading && <div style={{ fontSize: "10px", color: accent, marginTop: "2px" }}>Buffering...</div>}
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ marginTop: "16px", padding: "12px 14px", background: "var(--s1)", border: "1px solid var(--border)", borderRadius: "12px", fontSize: "10px", color: "var(--muted)", lineHeight: 1.6, textAlign: "center" }}>
          Audio streamed from <span style={{ color: accent, fontWeight: "700" }}>qurancentral.com</span> · All rights belong to the reciter
        </div>
      </div>

      {/* Mini player */}
      {playingNum !== null && (() => {
        const current = SURAHS.find(s => s.num === playingNum);
        if (!current) return null;
        const pct = duration > 0 ? (currentTime / duration) * 100 : 0;
        return (
          <div
            onClick={e => e.stopPropagation()}
            onTouchStart={e => e.stopPropagation()}
            style={{
              position: "fixed", left: 0, right: 0,
              bottom: "calc(68px + env(safe-area-inset-bottom))",
              maxWidth: "480px", margin: "0 auto",
              padding: "10px 14px",
              background: darkMode ? "rgba(10,14,20,0.96)" : "rgba(255,253,247,0.96)",
              backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)",
              borderTop: `1px solid ${accentBorder}`, zIndex: 90,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <button
                onClick={() => togglePlay(current)}
                style={{ width: "38px", height: "38px", borderRadius: "12px", background: accent, border: "none", color: "#000", fontSize: "14px", fontWeight: "800", cursor: "pointer", flexShrink: 0 }}
              >
                {loading ? <span style={{display:"inline-block",width:"14px",height:"14px",border:"2px solid rgba(0,0,0,0.2)",borderTopColor:"#000",borderRadius:"50%",animation:"spin 0.7s linear infinite"}}/> : isPlaying ? "⏸" : "▶"}
              </button>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "12px", fontWeight: "700", color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {current.name} · Yasser Al Dossari
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                  <span style={{ fontSize: "9px", color: "var(--muted)", fontVariantNumeric: "tabular-nums", minWidth: "32px" }}>{fmtTime(currentTime)}</span>
                  <input type="range" min="0" max={duration || 0} value={currentTime} onChange={e => seek(parseFloat(e.target.value))} onTouchStart={e => e.stopPropagation()} onTouchMove={e => e.stopPropagation()} style={{ flex: 1, height: "3px", accentColor: accent }} />
                  <span style={{ fontSize: "9px", color: "var(--muted)", fontVariantNumeric: "tabular-nums", minWidth: "32px", textAlign: "right" }}>{fmtTime(duration)}</span>
                </div>
                <div style={{ height: "2px", background: "var(--border)", borderRadius: "1px", overflow: "hidden", marginTop: "2px" }}>
                  <div style={{ height: "100%", width: `${pct}%`, background: accent, transition: "width 0.2s ease" }} />
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}
